<template>
  <div class="row">
    <div class="col-lg">
      <modal :show.sync="modals.submit" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <img src="@/assets/img/tick.png" width="300" />
            <br />
            <br />
            <br />
            <h1>{{ title }}</h1>
            <p>{{ message }}</p>
            <base-button class="btn-primary" @click="redirect()"
              >Done</base-button
            >
          </div>
        </div>
      </modal>
      <div class="row">
        <div class="col-lg">
          <card class="card-eprf">
            <div class="row">
              <div class="col-lg-3">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  JOB DETAILS
                </p>
                <p class="new-title">Reference No.</p>
                <p class="subtitle">{{ refno }}</p>

                <p class="new-title">Date Selected</p>
                <p class="subtitle">{{ dateselected }}</p>

                <br />
              </div>
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  VENDOR DETAILS
                </p>
                <p class="new-title">Vendor Name</p>
                <p class="subtitle">{{ vendorname }}</p>

                <p class="new-title">Vendor Phone Number</p>
                <p class="subtitle">{{ vendorphone }}</p>
                <br />
              </div>
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  DRIVER DETAILS
                </p>
                <p class="new-title">Driver Name</p>
                <p class="subtitle">{{ drivername }}</p>

                <p class="new-title">Driver NRIC</p>
                <p class="subtitle">{{ driveric }}</p>
              </div>
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  VEHICLE DETAILS
                </p>
                <p class="new-title">Plate Number</p>
                <p class="subtitle">{{ platenumber }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg">
                <div class="row">
                  <div class="col-lg">
                    <p
                      style="color: #358CCB; font-size: 24px; font-weight: 300"
                    >
                      UPLOADED IMAGES
                    </p>
                    <p class="new-title">Pre-operation</p>
                    <div class="row">
                      <div
                        class="col-lg-3"
                        v-for="(item, index) in preoperation"
                        :key="index"
                        style="padding-bottom: 5px"
                      >
                        <img :src="item.fileurl" width="73" height="45" />
                      </div>
                    </div>
                    <br />
                    <p class="new-title">During operation</p>
                    <div class="row">
                      <div
                        class="col-lg-3"
                        v-for="(item, index) in duringoperation"
                        :key="index"
                        style="padding-bottom: 5px"
                      >
                        <img :src="item.fileurl" width="73" height="45" />
                      </div>
                    </div>
                    <br />
                    <p class="new-title">Post-operation</p>
                    <div class="row">
                      <div
                        class="col-lg-3"
                        v-for="(item, index) in postoperation"
                        :key="index"
                        style="padding-bottom: 5px"
                      >
                        <img :src="item.fileurl" width="73" height="45" />
                      </div>
                    </div>
                    <br />
                    <p class="new-title">Inspection Photo</p>
                    <div class="row">
                      <div
                        class="col-lg-3"
                        v-for="(item, index) in inspection"
                        :key="index"
                        style="padding-bottom: 5px"
                      >
                        <img :src="item.fileurl" width="73" height="45" />
                      </div>
                    </div>
                    <br />
                    <p class="new-title">Other Operation</p>
                    <div class="row">
                      <div
                        class="col-lg-3"
                        v-for="(item, index) in other"
                        :key="index"
                        style="padding-bottom: 5px"
                      >
                        <img :src="item.fileurl" width="73" height="45" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg">
                <div class="row">
                  <div class="col-lg">
                    <p
                      style="color: #358CCB; font-size: 24px; font-weight: 300"
                    >
                      UPLOADED DOCUMENTS
                    </p>
                  </div>
                </div>
                <p class="new-title">PTW</p>

                <div v-for="(filee, index) in ptw" :key="index" class="row">
                  <div class="col-lg">
                    <div class="row">
                      <div class="col-lg text-left">
                        <a :href="filee.fileurl">
                          <base-button class="btn-link btn-primary">
                            {{ filee.filename }}
                          </base-button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="new-title">eCAF</p>

                <div v-for="(filee, index) in ecaf" :key="index" class="row">
                  <div class="col-lg">
                    <div class="row">
                      <div class="col-lg text-left">
                        <a :href="filee.fileurl">
                          <base-button class="btn-link btn-primary">
                            {{ filee.filename }}
                          </base-button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="new-title">Terminated PTW</p>

                <div
                  v-for="(filee, index) in terminatedptw"
                  :key="index"
                  class="row"
                >
                  <div class="col-lg">
                    <div class="row">
                      <div class="col-lg text-left">
                        <a :href="filee.fileurl">
                          <base-button class="btn-link btn-primary">
                            {{ filee.filename }}
                          </base-button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="new-title">Lab Report</p>

                <div
                  v-for="(filee, index) in labreport"
                  :key="index"
                  class="row"
                >
                  <div class="col-lg">
                    <div class="row">
                      <div class="col-lg text-left">
                        <a :href="filee.fileurl">
                          <base-button class="btn-link btn-primary">
                            {{ filee.filename }}
                          </base-button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="new-title">Weight Bridge Receipt</p>

                <div
                  v-for="(filee, index) in allTeminatedPTW"
                  :key="index"
                  class="row"
                >
                  <div class="col-lg">
                    <div class="row">
                      <div class="col-lg text-left">
                        <a :href="filee.fileurl">
                          <base-button class="btn-link btn-primary">
                            {{ filee.filename }}
                          </base-button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="new-title">Consignment Note</p>

                <div
                  v-for="(filee, index) in allLabReport"
                  :key="index"
                  class="row"
                >
                  <div class="col-lg">
                    <div class="row">
                      <div class="col-lg text-left">
                        <a :href="filee.fileurl">
                          <base-button class="btn-link btn-primary">
                            {{ filee.filename }}
                          </base-button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="new-title">Death Certificate</p>

                <div
                  v-for="(filee, index) in deathcertificate"
                  :key="index"
                  class="row"
                >
                  <div class="col-lg">
                    <div class="row">
                      <div class="col-lg text-left">
                        <a :href="filee.fileurl">
                          <base-button class="btn-link btn-primary">
                            {{ filee.filename }}
                          </base-button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <p class="new-title">Invoice</p>

                <div v-for="(filee, index) in invoice" :key="index" class="row">
                  <div class="col-lg">
                    <div class="row">
                      <div class="col-lg text-left">
                        <a :href="filee.fileurl">
                          <base-button class="btn-link btn-primary">
                            {{ filee.filename }}
                          </base-button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="row">
                  <div class="col-lg">
                    <p
                      style="color: #358CCB; font-size: 24px; font-weight: 300"
                    >
                      WASTE DETAILS
                    </p>
                    <div class="row" style="height: 450px; overflow: auto">
                      <div class="col-lg">
                        <el-table
                          :data="tableDatas"
                          :row-style="tableRowClassName"
                          :header-cell-style="{
                            background: '#358DCC',
                            border: 'transparent',
                            'font-size': '14px',
                            'font-weight': '400',
                            color: '#FFFFFF',
                          }"
                        >
                          <el-table-column
                            label="NO."
                            width="50"
                            align="center"
                          >
                            <div slot-scope="scope">
                              <p style="color: #707070">
                                {{ scope.$index + 1 }}
                              </p>
                            </div>
                          </el-table-column>
                          <el-table-column
                            :min-width="200"
                            align="center"
                            prop="wastetype"
                            label="WASTE TYPE"
                          >
                            <div slot-scope="{ row }">
                              <div align="left">
                                <p style="color: #707070">
                                  Waste Type: {{ row.wastetypename }}
                                </p>
                              </div>
                            </div>
                          </el-table-column>
                          <el-table-column
                            :min-width="150"
                            align="center"
                            prop="wasteComponents"
                            label="WASTE COMPONENT"
                          >
                            <template slot-scope="{ row }">
                              <div
                                v-for="(
                                  component, index
                                ) in row.wasteComponents"
                                :key="index"
                              >
                                {{ index + 1 }}. {{ component.name }}
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column
                            :min-width="150"
                            align="center"
                            prop="estqty"
                            label="QTY."
                          >
                            <div slot-scope="{ row }">
                              <p style="color: #707070">
                                {{ row.estqty }} {{ row.estqtyunit }}
                              </p>
                              <p style="color: #707070">
                                {{ row.estqtyy }} {{ row.estqtyyunit }}
                              </p>
                              <!-- only for != tyre -->
                            </div>
                          </el-table-column>
                          <el-table-column
                            :min-width="120"
                            align="center"
                            prop="remarks"
                            label="REMARKS"
                          >
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row"></div>
              </div>
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg text-right">
          <base-button wide type="danger" @click="prevTab" class="btn-previous">
            BACK
          </base-button>
          <base-button
            type="primary"
            wide
            class="btn-next"
            @click="completejob()"
            v-if="displayflag"
          >
            SUBMIT
          </base-button>
          <base-button
            type="primary"
            wide
            class="btn-next"
            @click="redirect"
            v-if="!displayflag"
          >
            DONE
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Circle8 } from "vue-loading-spinner";
import StatusModal from "src/components/StatusModal.vue";
import swal from "sweetalert2";
import moment from "moment";
import { Table, TableColumn } from "element-ui";
import { Modal } from "src/components";

export default {
  components: {
    Circle8,
    StatusModal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
  },
  data() {
    return {
      positionid: "",
      uploadload: false,
      allTeminatedPTW: [
        {
          fileid: "0",
          filename: "ABC File",
          fileurl: "",
        },
      ],
      allLabReport: [],
      labload: false,
      message: "",
      title: "",
      modals: {
        successModal: false,
        submit: false,
      },
      status: "",
      displayflag: false,
      dis: false,
      dateselected: "",
      refno: "",
      vendorname: "",
      vendorphone: "",
      platenumber: "",
      drivername: "",
      driveric: "",
      tableDatas: [],
      // picture
      preoperation: [],
      duringoperation: [],
      postoperation: [],
      inspection: [],
      other: [],
      // docs
      ptw: [],
      ecaf: [],
      terminatedptw: [],
      labreport: [],
      weightreceipt: [],
      cn: [],
      deathcertificate: [],
      invoice: [],
    };
  },
  methods: {
    completejob() {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          
          this.$http
            .post(
              ":10001/api/v1/outgoing/waste/" +
                this.$route.params.jobnum +
                "/complete"
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.title = "JOB REQUEST COMPLETED";
                this.message = response;
                this.modals.submit = true;
              }
            });
        }
      });
    },
    review() {
      this.$http
        .post(
          ":10001/api/v1/outgoing/waste/" +
            this.$route.params.jobnum +
            "/review"
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.getData();
          }
        });
    },
    onTerminatedChange(e) {
      this.uploadload = true;
      const t = e.target;
      const formData = new FormData();

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("documents", o);
      }
      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      this.$http
        .post(
          ":10001/api/v1/outgoing/waste/" +
            this.$route.params.jobnum +
            "/document/weight-bridge",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = "Documents successfully uploaded";
            this.modals.successModal = true;
            this.uploadload = false;
            this.getData();
          }
        });
    },
    onLabChange(e) {
      this.labload = true;
      const t = e.target;
      const formData = new FormData();

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("documents", o);
      }
      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      this.$http
        .post(
          ":10001/api/v1/outgoing/waste/" +
            this.$route.params.jobnum +
            "/document/consignment-note",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = "Documents successfully uploaded";
            this.modals.successModal = true;
            this.labload = false;
            this.getData();
          }
        });
    },
    removeLab(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/outgoing/waste/" +
                this.$route.params.jobnum +
                "/document/consignment-note/" +
                fileid
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.successModal = true;

                setTimeout(() => {
                  this.getData();
                }, 1000);
              }
            });
        }
      });
    },
    removeSignedDO(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/outgoing/waste/" +
                this.$route.params.jobnum +
                "/document/weight-bridge/" +
                fileid
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.successModal = true;

                setTimeout(() => {
                  this.getData();
                }, 1000);
              }
            });
        }
      });
    },
    backtolist() {
      this.$http
        .post(
          ":10001/api/v1/outgoing/product/" +
            this.$route.params.refno +
            "/terminate_ptw/submit"
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.message = response;
            this.modals.successModal = true;
            console.log(response);

            setTimeout(() => {
              this.redirect();
            }, 1000);
          }
        });
    },
    redirect() {
      this.$router.push("/Outgoing");
    },
    prevTab() {
      let parameter = {
        step: "8",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    nextTab() {
      let parameter = {
        step: "6",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    getData() {
      this.allTeminatedPTW = [];
      this.allLabReport = [];
      this.ptw = [];
      this.ecaf = [];
      this.terminatedptw = [];
      this.labreport = [];
      this.deathcertificate = [];
      this.invoice = [];

      this.preoperation = [];
      this.duringoperation = [];
      this.postoperation = [];
      this.inspection = [];
      this.other = [];

      this.$http
        .get(":10001/api/v1/outgoing/waste/" + this.$route.params.jobnum)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.status = response.status.status;

            // weight bridge
            for (var i = 0; i < response.weight_bridge.length; i++) {
              let obj = {
                fileid: response.weight_bridge[i].document_id,
                filename: response.weight_bridge[i].meta.filename,
                fileurl: response.weight_bridge[i].url,
              };
              this.allTeminatedPTW.push(obj);
            }

            // cn
            for (var i = 0; i < response.consignment_note.length; i++) {
              let obj = {
                fileid: response.consignment_note[i].document_id,
                filename: response.consignment_note[i].meta.filename,
                fileurl: response.consignment_note[i].url,
              };
              this.allLabReport.push(obj);
            }

            if (
              this.allTeminatedPTW.length != 0 &&
              this.allLabReport.length != 0
            ) {
              this.dis = false;
            } else {
              this.dis = true;
            }

            this.refno = response.reference_number;
            this.dateselected = moment(response.accepted_at).format(
              "YYYY-MM-DD"
            );
            this.vendorname = response.company_vendor.company_name;
            this.vendorphone = response.company_vendor.phone_number;
            this.platenumber = response.vehicle.vehicle_reg_num;
            this.drivername = response.driver.driver_name;
            this.driveric = response.driver.driver_nric;

            for (var i = 0; i < response.waste_detail.length; i++) {
              let component = [];

              for (
                var j = 0;
                j < response.waste_detail[i].waste_component.length;
                j++
              ) {
                console.log(response.waste_detail[i].waste_component[j]);
                component.push({
                  name: response.waste_detail[i].waste_component[j],
                });
              }
              let obj = {
                wastetypename: response.waste_detail[i].waste_type.name,
                wasteComponents: component,
                estqty: response.waste_detail[i].quantity,
                estqtyunit: response.waste_detail[i].quantity_unit,
                estqtyy: response.waste_detail[i].packaging_quantity,
                estqtyyunit: response.waste_detail[i].packaging.name,
                remarks: response.waste_detail[i].remark,
              };
              this.tableDatas.push(obj);
            }

            // get pre operation photo
            for (var i = 0; i < response.operation_photo.length; i++) {
              if (response.operation_photo[i].index == 0) {
                let obj = {
                  filename: response.operation_photo[i].meta.filename,
                  fileid: response.operation_photo[i].document_id,
                  fileurl: response.operation_photo[i].url,
                };
                this.preoperation.push(obj);
              } else if (response.operation_photo[i].index == 1) {
                let obj = {
                  filename: response.operation_photo[i].meta.filename,
                  fileid: response.operation_photo[i].document_id,
                  fileurl: response.operation_photo[i].url,
                };
                this.duringoperation.push(obj);
              } else if (response.operation_photo[i].index == 2) {
                let obj = {
                  filename: response.operation_photo[i].meta.filename,
                  fileid: response.operation_photo[i].document_id,
                  fileurl: response.operation_photo[i].url,
                };
                this.postoperation.push(obj);
              } else if (response.operation_photo[i].index == 3) {
                let obj = {
                  filename: response.operation_photo[i].meta.filename,
                  fileid: response.operation_photo[i].document_id,
                  fileurl: response.operation_photo[i].url,
                };
                this.inspection.push(obj);
              } else if (response.operation_photo[i].index == 4) {
                let obj = {
                  filename: response.operation_photo[i].meta.filename,
                  fileid: response.operation_photo[i].document_id,
                  fileurl: response.operation_photo[i].url,
                };
                this.other.push(obj);
              }
            }

            // get PTW doc
            for (var i = 0; i < response.ptw_document.length; i++) {
              let obj = {
                filename: response.ptw_document[i].meta.filename,
                fileurl: response.ptw_document[i].url,
                fileid: response.ptw_document[i].document_id,
              };
              this.ptw.push(obj);
            }

            // get eCAF doc
            for (var i = 0; i < response.ecaf_document.length; i++) {
              let obj = {
                filename: response.ecaf_document[i].meta.filename,
                fileurl: response.ecaf_document[i].url,
                fileid: response.ecaf_document[i].document_id,
              };
              this.ecaf.push(obj);
            }

            // terminated PTW
            for (var i = 0; i < response.terminated_ptw_document.length; i++) {
              let obj = {
                fileid: response.terminated_ptw_document[i].document_id,
                filename: response.terminated_ptw_document[i].meta.filename,
                fileurl: response.terminated_ptw_document[i].url,
              };
              this.terminatedptw.push(obj);
            }

            // lab report
            for (var i = 0; i < response.lab_report.length; i++) {
              let obj = {
                fileid: response.lab_report[i].document_id,
                filename: response.lab_report[i].meta.filename,
                fileurl: response.lab_report[i].url,
              };
              this.labreport.push(obj);
            }

            // death certificate
            for (var i = 0; i < response.death_certificate.length; i++) {
              let obj = {
                fileid: response.death_certificate[i].document_id,
                filename: response.death_certificate[i].meta.filename,
                fileurl: response.death_certificate[i].url,
              };
              this.deathcertificate.push(obj);
            }

            // invoice
            for (var i = 0; i < response.invoice.length; i++) {
              let obj = {
                fileid: response.invoice[i].document_id,
                filename: response.invoice[i].meta.filename,
                fileurl: response.invoice[i].url,
              };
              this.invoice.push(obj);
            }
          }
        });
    },
    tableRowClassName({ row, rowIndex }) {
      // console.log(rowIndex % 2);
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },
  },
  created() {
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
    this.getData();
  },
  watch: {
    positionid() {
      console.log(this.positionid);
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
    status() {
      console.log(this.status);
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
    displayflag() {
      console.log(this.displayflag);
    },
  },
};
</script>
<style scoped>
.newtitle {
  color: #707070;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}
</style>
